<div class="multiple-wrap   text-base">
  <div class="mx:flex font-bold sm:hidden">
    <span class="flex-1 items-center  mr-8 ml-4">{{"ADD_ITEM" | translate}}</span>
    <span class="flex-1 items-center  mr-8 ml-4">{{"ADD_DATE" | translate}}</span>
    <span class="flex-1 items-center  mr-8 ml-4">{{"ADD_QTY" | translate}}</span>
    <span class="text-center cursor-pointer w-[80px]">{{"ADD_DEL" | translate}}</span>
  </div>
  <form [formGroup]="form" class="mt-4">
    <div formArrayName="itemsFormArray">
      <div *ngFor="let item of itemsFormArray.controls; let i = index">
        <div [formGroupName]="i.toString()">
          <nz-form-item class="flex">
            <div class="mx:flex w100" >
              <input (focus)="onFocusLastMaterialNumber(i)" nz-input [placeholder]="'ADD_ITEM' | translate" class="sm:w-full mx:flex-1 items-center h-[80px] mr-8" formControlName="materialNumber" />
              <nz-date-picker [nzAllowClear]="false" [nzSuffixIcon]="suffixDate" formControlName="date" [nzPlaceHolder]="'ADD_DATE' | translate"
                class="sm:w-full mx:flex-1 items-center h-[80px] mr-8" nzFormat="yyyy-MM-dd" [nzShowToday]="false" [nzRenderExtraFooter]="footerRender" [nzDisabledDate]="disabledDate"></nz-date-picker>
              <ng-container *nzSuffix><i class="beforeIcon"></i></ng-container>
              <nz-input-group [nzSuffix]="suffixTemplateInfo" [nzPrefix]="prefixTemplateUser" class="sm:w-full mx:flex-1 items-center h-[80px] mr-8 qty">
                <input type="number" nz-input placeholder="" min="0" step="1" formControlName="quantity" />
              </nz-input-group>
              <ng-template #footerRender> <div class="flex-center"><a (click)="chooseDate(item)">{{'ADD_ONE_WEEK' | translate}}</a></div></ng-template>
              <ng-template #suffixDate><i class="calender"></i></ng-template>
              <ng-template #prefixTemplateUser><i class="beforeIcon" (click)="minusQuantity(i)"></i></ng-template>
              <ng-template #suffixTemplateInfo><i class="afterIcon" (click)="addQuantity(i)"></i></ng-template>
              <div class="sm:flex sm:justify-end">
                <div class="multiple-wrap-del-icon w-[80px] h-[80px] cursor-pointer flex-center" (click)="removeFormItem(i)"><i class="delete-icon"></i>
                </div>
              </div>
            </div>
            <div class="multiple-wrap-errors" *ngIf="item.get('materialNumber')!.hasError('materialNumberValidator')">
              {{ item.get('materialNumber')!.getError('materialNumberValidator')?.desc }}
            </div>
          </nz-form-item>

        </div>
      </div>
    </div>
  </form>
  <div class="flex items-center mb-8 cursor-pointer">
    <svg-icon [iconName]="'new/close-blue.svg'"  class="mr-2"></svg-icon>
    <span class="text-primaryBlue" (click)="clearAll()">{{"ADD_CLEAR" | translate}}</span>
  </div>
</div>

<nz-modal [(nzVisible)]="isVisible" [nzTitle]="" nzCentered (nzOnCancel)="isVisible=false" [nzClosable]="false" class="myModal">
  <div *nzModalContent>
    <p class="model-content"> {{"ADD_MULTIPLE_TIPS" | translate}}</p>
  </div>
  <div *nzModalFooter class="flex-center">
    <button nz-button nzType="default" (click)="isVisible=false"><i nz-icon nzType="close"></i> {{"CLOSE" | translate}}</button>
    <button nz-button nzType="primary" (click)="addToCart()" class="flex-center"> {{"CONTINUE_TO_CART" | translate}}<i class="cart"></i></button>
  </div>
</nz-modal>
